import {MyopBindMessage, MyopBindReplayMessage, Ref} from "./BaseMessage";
import {MyopMessageKey} from "../common/MyopMessages";

const ReplayMessageKey = 'ClickReplayMessage'

export class BindClickMessage extends MyopBindMessage<void, ClickReplayMessage> {
    replyMessageKey: MyopMessageKey = ReplayMessageKey
    messageType = 'BindClickMessage';
    cleanable = true;

    constructor(public ref: Ref, handler: (message: ClickReplayMessage) => void) {
        super(handler);
    }
}

export class ClickReplayMessage extends MyopBindReplayMessage {
    messageType = ReplayMessageKey
}

